import { useState } from 'react';
import { Link } from 'react-router';
import { useUserStore } from '../../stores/userStore';
import { Dropdown } from '../ui/dropdown/Dropdown';
import { DropdownItem } from '../ui/dropdown/DropdownItem';

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  function toggleDropdown() {
    setIsOpen(!isOpen);
  }

  function closeDropdown() {
    setIsOpen(false);
  }

  const user = useUserStore((state) => state.user);

  return (
    <div className='relative'>
      <button onClick={toggleDropdown} className='flex items-center text-gray-700 dropdown-toggle dark:text-gray-400'>
        <span className='mr-3 overflow-hidden rounded-full h-11 w-11 relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'>
          <img src='/images/user/master_profile.png' alt='User' className='ml-0.5 mt-1.5 ' width={35} height={35} />
        </span>

        <span className='block mr-1 font-medium text-theme-sm'>{user?.name || 'Unknown User'}</span>
        <svg
          className={`stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
          width='18'
          height='20'
          viewBox='0 0 18 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M4.3125 8.65625L9 13.3437L13.6875 8.65625'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className='absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-700 dark:bg-gray-dark'>
        <div>
          <span className='block font-medium text-gray-700 text-theme-sm dark:text-gray-400'>
            {user?.name || 'Unknown User'}
          </span>
          <span className='mt-0.5 block text-theme-xs text-gray-500 dark:text-gray-400'>
            {user?.email || 'No email'}
          </span>
        </div>

        <ul className='flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200 dark:border-gray-700'>
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag='a'
              to='/profile'
              className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'>
              {/* 아이콘 생략 */}
              프로필 수정
            </DropdownItem>
          </li>
        </ul>
        <Link
          to='/signout?ggg=tt'
          className='flex items-center gap-3 px-3 py-2 mt-3 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'>
          {/* 아이콘 생략 */}
          로그아웃
        </Link>
      </Dropdown>
    </div>
  );
}
